export default "__VITE_ASSET__HDZrNs3G__"